"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SemanticContext = void 0; // ConvertTo-TS run at 2016-10-04T11:26:36.9521478-07:00

var Array2DHashSet_1 = require("../misc/Array2DHashSet");

var ArrayEqualityComparator_1 = require("../misc/ArrayEqualityComparator");

var MurmurHash_1 = require("../misc/MurmurHash");

var Decorators_1 = require("../Decorators");

var ObjectEqualityComparator_1 = require("../misc/ObjectEqualityComparator");

var Utils = require("../misc/Utils");

function max(items) {
  var result;

  var _iterator = _createForOfIteratorHelper(items),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var current = _step.value;

      if (result === undefined) {
        result = current;
        continue;
      }

      var comparison = result.compareTo(current);

      if (comparison < 0) {
        result = current;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
}

function min(items) {
  var result;

  var _iterator2 = _createForOfIteratorHelper(items),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var current = _step2.value;

      if (result === undefined) {
        result = current;
        continue;
      }

      var comparison = result.compareTo(current);

      if (comparison > 0) {
        result = current;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return result;
}
/** A tree structure used to record the semantic context in which
 *  an ATN configuration is valid.  It's either a single predicate,
 *  a conjunction `p1&&p2`, or a sum of products `p1||p2`.
 *
 *  I have scoped the {@link AND}, {@link OR}, and {@link Predicate} subclasses of
 *  {@link SemanticContext} within the scope of this outer class.
 */


var SemanticContext = /*#__PURE__*/function () {
  function SemanticContext() {
    _classCallCheck(this, SemanticContext);
  }

  _createClass(SemanticContext, [{
    key: "evalPrecedence",
    value:
    /**
     * Evaluate the precedence predicates for the context and reduce the result.
     *
     * @param parser The parser instance.
     * @param parserCallStack
     * @returns The simplified semantic context after precedence predicates are
     * evaluated, which will be one of the following values.
     *
     * * {@link #NONE}: if the predicate simplifies to `true` after
     *   precedence predicates are evaluated.
     * * `undefined`: if the predicate simplifies to `false` after
     *   precedence predicates are evaluated.
     * * `this`: if the semantic context is not changed as a result of
     *   precedence predicate evaluation.
     * * A non-`undefined` {@link SemanticContext}: the new simplified
     *   semantic context after precedence predicates are evaluated.
     */
    function evalPrecedence(parser, parserCallStack) {
      return this;
    }
  }], [{
    key: "NONE",
    get:
    /**
     * The default {@link SemanticContext}, which is semantically equivalent to
     * a predicate of the form `{true}?`.
     */
    function get() {
      if (SemanticContext._NONE === undefined) {
        SemanticContext._NONE = new SemanticContext.Predicate();
      }

      return SemanticContext._NONE;
    }
  }, {
    key: "and",
    value: function and(a, b) {
      if (!a || a === SemanticContext.NONE) {
        return b;
      }

      if (b === SemanticContext.NONE) {
        return a;
      }

      var result = new SemanticContext.AND(a, b);

      if (result.opnds.length === 1) {
        return result.opnds[0];
      }

      return result;
    }
    /**
     *
     *  @see ParserATNSimulator#getPredsForAmbigAlts
     */

  }, {
    key: "or",
    value: function or(a, b) {
      if (!a) {
        return b;
      }

      if (a === SemanticContext.NONE || b === SemanticContext.NONE) {
        return SemanticContext.NONE;
      }

      var result = new SemanticContext.OR(a, b);

      if (result.opnds.length === 1) {
        return result.opnds[0];
      }

      return result;
    }
  }]);

  return SemanticContext;
}();

exports.SemanticContext = SemanticContext;

(function (SemanticContext) {
  /**
   * This random 30-bit prime represents the value of `AND.class.hashCode()`.
   */
  var AND_HASHCODE = 40363613;
  /**
   * This random 30-bit prime represents the value of `OR.class.hashCode()`.
   */

  var OR_HASHCODE = 486279973;

  function filterPrecedencePredicates(collection) {
    var result = [];

    for (var i = 0; i < collection.length; i++) {
      var context = collection[i];

      if (context instanceof SemanticContext.PrecedencePredicate) {
        result.push(context); // Remove the item from 'collection' and move i back so we look at the same index again

        collection.splice(i, 1);
        i--;
      }
    }

    return result;
  }

  var Predicate = /*#__PURE__*/function (_SemanticContext) {
    _inherits(Predicate, _SemanticContext);

    var _super = _createSuper(Predicate);

    function Predicate() {
      var _this;

      var ruleIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
      var predIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
      var isCtxDependent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      _classCallCheck(this, Predicate);

      _this = _super.call(this);
      _this.ruleIndex = ruleIndex;
      _this.predIndex = predIndex;
      _this.isCtxDependent = isCtxDependent;
      return _this;
    }

    _createClass(Predicate, [{
      key: "eval",
      value: function _eval(parser, parserCallStack) {
        var localctx = this.isCtxDependent ? parserCallStack : undefined;
        return parser.sempred(localctx, this.ruleIndex, this.predIndex);
      }
    }, {
      key: "hashCode",
      value: function hashCode() {
        var hashCode = MurmurHash_1.MurmurHash.initialize();
        hashCode = MurmurHash_1.MurmurHash.update(hashCode, this.ruleIndex);
        hashCode = MurmurHash_1.MurmurHash.update(hashCode, this.predIndex);
        hashCode = MurmurHash_1.MurmurHash.update(hashCode, this.isCtxDependent ? 1 : 0);
        hashCode = MurmurHash_1.MurmurHash.finish(hashCode, 3);
        return hashCode;
      }
    }, {
      key: "equals",
      value: function equals(obj) {
        if (!(obj instanceof Predicate)) {
          return false;
        }

        if (this === obj) {
          return true;
        }

        return this.ruleIndex === obj.ruleIndex && this.predIndex === obj.predIndex && this.isCtxDependent === obj.isCtxDependent;
      }
    }, {
      key: "toString",
      value: function toString() {
        return "{" + this.ruleIndex + ":" + this.predIndex + "}?";
      }
    }]);

    return Predicate;
  }(SemanticContext);

  __decorate([Decorators_1.Override], Predicate.prototype, "eval", null);

  __decorate([Decorators_1.Override], Predicate.prototype, "hashCode", null);

  __decorate([Decorators_1.Override], Predicate.prototype, "equals", null);

  __decorate([Decorators_1.Override], Predicate.prototype, "toString", null);

  SemanticContext.Predicate = Predicate;

  var PrecedencePredicate = /*#__PURE__*/function (_SemanticContext2) {
    _inherits(PrecedencePredicate, _SemanticContext2);

    var _super2 = _createSuper(PrecedencePredicate);

    function PrecedencePredicate(precedence) {
      var _this2;

      _classCallCheck(this, PrecedencePredicate);

      _this2 = _super2.call(this);
      _this2.precedence = precedence;
      return _this2;
    }

    _createClass(PrecedencePredicate, [{
      key: "eval",
      value: function _eval(parser, parserCallStack) {
        return parser.precpred(parserCallStack, this.precedence);
      }
    }, {
      key: "evalPrecedence",
      value: function evalPrecedence(parser, parserCallStack) {
        if (parser.precpred(parserCallStack, this.precedence)) {
          return SemanticContext.NONE;
        } else {
          return undefined;
        }
      }
    }, {
      key: "compareTo",
      value: function compareTo(o) {
        return this.precedence - o.precedence;
      }
    }, {
      key: "hashCode",
      value: function hashCode() {
        var hashCode = 1;
        hashCode = 31 * hashCode + this.precedence;
        return hashCode;
      }
    }, {
      key: "equals",
      value: function equals(obj) {
        if (!(obj instanceof PrecedencePredicate)) {
          return false;
        }

        if (this === obj) {
          return true;
        }

        return this.precedence === obj.precedence;
      }
    }, {
      key: "toString",
      value: function toString() {
        return "{" + this.precedence + ">=prec}?";
      }
    }]);

    return PrecedencePredicate;
  }(SemanticContext);

  __decorate([Decorators_1.Override], PrecedencePredicate.prototype, "eval", null);

  __decorate([Decorators_1.Override], PrecedencePredicate.prototype, "evalPrecedence", null);

  __decorate([Decorators_1.Override], PrecedencePredicate.prototype, "compareTo", null);

  __decorate([Decorators_1.Override], PrecedencePredicate.prototype, "hashCode", null);

  __decorate([Decorators_1.Override], PrecedencePredicate.prototype, "equals", null);

  __decorate([Decorators_1.Override], PrecedencePredicate.prototype, "toString", null);

  SemanticContext.PrecedencePredicate = PrecedencePredicate;
  /**
   * This is the base class for semantic context "operators", which operate on
   * a collection of semantic context "operands".
   *
   * @since 4.3
   */

  var Operator = /*#__PURE__*/function (_SemanticContext3) {
    _inherits(Operator, _SemanticContext3);

    var _super3 = _createSuper(Operator);

    function Operator() {
      _classCallCheck(this, Operator);

      return _super3.apply(this, arguments);
    }

    return Operator;
  }(SemanticContext);

  SemanticContext.Operator = Operator;
  /**
   * A semantic context which is true whenever none of the contained contexts
   * is false.
   */

  var AND = /*#__PURE__*/function (_Operator) {
    _inherits(AND, _Operator);

    var _super4 = _createSuper(AND);

    function AND(a, b) {
      var _this3;

      _classCallCheck(this, AND);

      _this3 = _super4.call(this);
      var operands = new Array2DHashSet_1.Array2DHashSet(ObjectEqualityComparator_1.ObjectEqualityComparator.INSTANCE);

      if (a instanceof AND) {
        operands.addAll(a.opnds);
      } else {
        operands.add(a);
      }

      if (b instanceof AND) {
        operands.addAll(b.opnds);
      } else {
        operands.add(b);
      }

      _this3.opnds = operands.toArray();
      var precedencePredicates = filterPrecedencePredicates(_this3.opnds); // interested in the transition with the lowest precedence

      var reduced = min(precedencePredicates);

      if (reduced) {
        _this3.opnds.push(reduced);
      }

      return _this3;
    }

    _createClass(AND, [{
      key: "operands",
      get: function get() {
        return this.opnds;
      }
    }, {
      key: "equals",
      value: function equals(obj) {
        if (this === obj) {
          return true;
        }

        if (!(obj instanceof AND)) {
          return false;
        }

        return ArrayEqualityComparator_1.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
      }
    }, {
      key: "hashCode",
      value: function hashCode() {
        return MurmurHash_1.MurmurHash.hashCode(this.opnds, AND_HASHCODE);
      }
      /**
       * {@inheritDoc}
       *
       * The evaluation of predicates by this context is short-circuiting, but
       * unordered.
       */

    }, {
      key: "eval",
      value: function _eval(parser, parserCallStack) {
        var _iterator3 = _createForOfIteratorHelper(this.opnds),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var opnd = _step3.value;

            if (!opnd.eval(parser, parserCallStack)) {
              return false;
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        return true;
      }
    }, {
      key: "evalPrecedence",
      value: function evalPrecedence(parser, parserCallStack) {
        var differs = false;
        var operands = [];

        var _iterator4 = _createForOfIteratorHelper(this.opnds),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var context = _step4.value;
            var evaluated = context.evalPrecedence(parser, parserCallStack);
            differs = differs || evaluated !== context;

            if (evaluated == null) {
              // The AND context is false if any element is false
              return undefined;
            } else if (evaluated !== SemanticContext.NONE) {
              // Reduce the result by skipping true elements
              operands.push(evaluated);
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        if (!differs) {
          return this;
        }

        if (operands.length === 0) {
          // all elements were true, so the AND context is true
          return SemanticContext.NONE;
        }

        var result = operands[0];

        for (var i = 1; i < operands.length; i++) {
          result = SemanticContext.and(result, operands[i]);
        }

        return result;
      }
    }, {
      key: "toString",
      value: function toString() {
        return Utils.join(this.opnds, "&&");
      }
    }]);

    return AND;
  }(Operator);

  __decorate([Decorators_1.Override], AND.prototype, "operands", null);

  __decorate([Decorators_1.Override], AND.prototype, "equals", null);

  __decorate([Decorators_1.Override], AND.prototype, "hashCode", null);

  __decorate([Decorators_1.Override], AND.prototype, "eval", null);

  __decorate([Decorators_1.Override], AND.prototype, "evalPrecedence", null);

  __decorate([Decorators_1.Override], AND.prototype, "toString", null);

  AND = __decorate([__param(0, Decorators_1.NotNull), __param(1, Decorators_1.NotNull)], AND);
  SemanticContext.AND = AND;
  /**
   * A semantic context which is true whenever at least one of the contained
   * contexts is true.
   */

  var OR = /*#__PURE__*/function (_Operator2) {
    _inherits(OR, _Operator2);

    var _super5 = _createSuper(OR);

    function OR(a, b) {
      var _this4;

      _classCallCheck(this, OR);

      _this4 = _super5.call(this);
      var operands = new Array2DHashSet_1.Array2DHashSet(ObjectEqualityComparator_1.ObjectEqualityComparator.INSTANCE);

      if (a instanceof OR) {
        operands.addAll(a.opnds);
      } else {
        operands.add(a);
      }

      if (b instanceof OR) {
        operands.addAll(b.opnds);
      } else {
        operands.add(b);
      }

      _this4.opnds = operands.toArray();
      var precedencePredicates = filterPrecedencePredicates(_this4.opnds); // interested in the transition with the highest precedence

      var reduced = max(precedencePredicates);

      if (reduced) {
        _this4.opnds.push(reduced);
      }

      return _this4;
    }

    _createClass(OR, [{
      key: "operands",
      get: function get() {
        return this.opnds;
      }
    }, {
      key: "equals",
      value: function equals(obj) {
        if (this === obj) {
          return true;
        }

        if (!(obj instanceof OR)) {
          return false;
        }

        return ArrayEqualityComparator_1.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
      }
    }, {
      key: "hashCode",
      value: function hashCode() {
        return MurmurHash_1.MurmurHash.hashCode(this.opnds, OR_HASHCODE);
      }
      /**
       * {@inheritDoc}
       *
       * The evaluation of predicates by this context is short-circuiting, but
       * unordered.
       */

    }, {
      key: "eval",
      value: function _eval(parser, parserCallStack) {
        var _iterator5 = _createForOfIteratorHelper(this.opnds),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var opnd = _step5.value;

            if (opnd.eval(parser, parserCallStack)) {
              return true;
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        return false;
      }
    }, {
      key: "evalPrecedence",
      value: function evalPrecedence(parser, parserCallStack) {
        var differs = false;
        var operands = [];

        var _iterator6 = _createForOfIteratorHelper(this.opnds),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var context = _step6.value;
            var evaluated = context.evalPrecedence(parser, parserCallStack);
            differs = differs || evaluated !== context;

            if (evaluated === SemanticContext.NONE) {
              // The OR context is true if any element is true
              return SemanticContext.NONE;
            } else if (evaluated) {
              // Reduce the result by skipping false elements
              operands.push(evaluated);
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        if (!differs) {
          return this;
        }

        if (operands.length === 0) {
          // all elements were false, so the OR context is false
          return undefined;
        }

        var result = operands[0];

        for (var i = 1; i < operands.length; i++) {
          result = SemanticContext.or(result, operands[i]);
        }

        return result;
      }
    }, {
      key: "toString",
      value: function toString() {
        return Utils.join(this.opnds, "||");
      }
    }]);

    return OR;
  }(Operator);

  __decorate([Decorators_1.Override], OR.prototype, "operands", null);

  __decorate([Decorators_1.Override], OR.prototype, "equals", null);

  __decorate([Decorators_1.Override], OR.prototype, "hashCode", null);

  __decorate([Decorators_1.Override], OR.prototype, "eval", null);

  __decorate([Decorators_1.Override], OR.prototype, "evalPrecedence", null);

  __decorate([Decorators_1.Override], OR.prototype, "toString", null);

  OR = __decorate([__param(0, Decorators_1.NotNull), __param(1, Decorators_1.NotNull)], OR);
  SemanticContext.OR = OR;
})(SemanticContext = exports.SemanticContext || (exports.SemanticContext = {}));